import { TabStyles } from '@tableau/widgets';
import { NestedCSSProperties } from 'typestyle/lib/types';
import { cssClass, divWithStyle, vizPortalFontStyle } from '../../../data-catalog-shared';

export const descriptionMaxHeight = 60;
const rowHeight = TabStyles.Typography.Sizing.XLarge;

export const ColumnDetailsPane = divWithStyle('ColumnDetailsPane', {
  ...vizPortalFontStyle,
  fontSize: TabStyles.Typography.Sizing.Default,
});

export const ColumnDetailsColumnName = divWithStyle('ColumnDetailsColumnName', {
  fontSize: TabStyles.Typography.Sizing.XLarge,
});

export const ColumnDetailsTypeRow = divWithStyle('ColumnDetailsTypeRow', {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  paddingTop: TabStyles.Spacing.DefaultSpace,
});

export const ColumnDetailsProperties = divWithStyle('ColumnDetailsProperties', {
  display: 'table',
  paddingTop: TabStyles.Spacing.DefaultSpace,
  width: '100%',
});

export const ActionMenuProperties = divWithStyle('ActionsMenuProperties', {
  position: 'absolute',
  verticalAlign: 'middle',
  right: TabStyles.Spacing.ExtraLargeSpace,
  display: 'flex',
  flexDirection: 'column',
});

export const columnActionsMenuStyle: React.CSSProperties = {
  marginLeft: TabStyles.Spacing.MediumSpace,
};

export const inlineActionsMenuButtonStyle: React.CSSProperties = {
  padding: TabStyles.Spacing.SmallSpace,
  cursor: 'pointer',
  verticalAlign: 'middle',
  minWidth: 0,
  height: TabStyles.Sizing.RowHeight,
  width: TabStyles.Sizing.RowHeight,
};

export const detailsDialogActionsMenuButtonStyle: React.CSSProperties = {
  padding: TabStyles.Spacing.SmallSpace,
  cursor: 'pointer',
  verticalAlign: 'middle',
  minWidth: 0,
  height: TabStyles.Sizing.RowHeight + 5,
  width: TabStyles.Sizing.RowHeight + 5,
};

export const SaveAndCancelButtonsWrapper = divWithStyle('SaveAndCancelButtonsWrapper', {
  position: 'relative'
});

export const SaveAndCancelButtonsFlexWrapperSharedStyle: NestedCSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  marginTop: TabStyles.Spacing.DefaultSpace * 2,
  marginBottom: TabStyles.Spacing.DefaultSpace,
  marginLeft: TabStyles.Spacing.DefaultSpace,
};

export const columnDetailsTextAreaStyle: React.CSSProperties = {
  marginTop: 10,
  fontSize: TabStyles.Typography.Sizing.Default,
  fontFamily: TabStyles.Typography.FontFamily,
  color: TabStyles.Typography.Color.Primary,
  resize: 'none',
  outline: 'none',
  flex: 1,
  width: '100%',
};

export const ColumnAndFieldDetailsProperty = divWithStyle('ColumnAndFieldDetailsProperty', {
  display: 'table-row',
});

export const ColumnAndFieldDetailsLabel = divWithStyle('ColumnAndFieldDetailsLabel', {
  display: 'table-cell',
  padding: TabStyles.Spacing.DefaultSpace,
  color: TabStyles.Typography.Color.Secondary,
  textAlign: 'right',
  whiteSpace: 'nowrap',
  verticalAlign: 'top',
});

export const ColumnAndFieldDetailsValue = divWithStyle('ColumnAndFieldDetailsValue', {
  padding: TabStyles.Spacing.DefaultSpace,
  maxWidth: '300px',
  maxHeight: '150px',
  overflow: 'auto',
});

export const ColumnAndFieldDetailsDescriptionValue = divWithStyle('ColumnAndFieldDetailsDescriptionValue', {
  display: 'table-cell',
  padding: TabStyles.Spacing.DefaultSpace,
  overflowY: 'auto',
  wordBreak: 'break-word',
});

export const ColumnAndFieldDetailsTableCell = divWithStyle('ColumnAndFieldDetailsTableCell', {
  display: 'table-cell'
});

export const ColumnAndFieldDetailsTextAreaWrapper = divWithStyle('ColumnAndFieldDetailsTextAreaWrapper', {
  display: 'flex',
});

export const ColumnAndFieldDetailsTagsEditorWrapper = divWithStyle('ColumnAndFieldDetailsTagsEditorWrapper', {
  flex: '1 1 0%',
  marginTop: TabStyles.Spacing.DefaultSpace,
});

export const ColumnDetailsPlaceholder = divWithStyle('ColumnDetailsPlaceholder', {
  fontStyle: 'italic',
  color: TabStyles.Typography.Color.Secondary,
});

export const columnFieldsWrapperMaxRows = 4.5;

export const ColumnFieldsWrapper = divWithStyle('ColumnFieldsWrapper', {
  width: '100%',
  lineHeight: `${rowHeight}px`,
  verticalAlign: 'top',
  display: 'table-cell',
  padding: TabStyles.Spacing.DefaultSpace,
  $nest: {
    '> div': {
      height: 'inherit',
      maxHeight: rowHeight * columnFieldsWrapperMaxRows,
      overflow: 'auto',
    }
  }
});

export const columnAndFieldDetailsLabelsStyle: React.CSSProperties = {
  marginLeft: TabStyles.Spacing.DefaultSpace + 2,
  marginTop: TabStyles.Spacing.SmallSpace,
  display: 'inline-block'
};

export const flowFieldDetailsLabelsStyle: React.CSSProperties = {
  marginLeft: TabStyles.Spacing.DefaultSpace + 2,
  marginTop: TabStyles.Spacing.DefaultSpace,
  display: 'inline-block'
};

export const searchFieldFilter = cssClass('search-field-filter',
  {
    display: 'flex',
    flexFlow: 'column',
    overflow: 'auto',
    alignSelf: 'flex-end'
  }
);

export const filterField = cssClass('filter-field',
  {
    display: 'flex',
    flexFlow: 'column',
    alignSelf: 'flex-end',
    margin: '0pt 10pt'
  }
);

export const searchFilterDiv = cssClass('search-filter-div', 
  {
    display: 'flex',
    alignSelf: 'flex-end'
  }
);

export const searchFieldDiv = cssClass('search-field-div',
  {
    display: 'flex',
    flexFlow: 'column',
    flexGrow: 'inherit'
  }
);

export const searchDataGrid = cssClass('search-data-grid',
  {
    display: 'flex',
    flexFlow: 'column',
    flexGrow: 'inherit'
  }
);